/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleAuditUserResponseDto
 */
export interface RoleAuditUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RoleAuditUserResponseDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RoleAuditUserResponseDto
     */
    lastName: string;
}

/**
 * Check if a given object implements the RoleAuditUserResponseDto interface.
 */
export function instanceOfRoleAuditUserResponseDto(value: object): value is RoleAuditUserResponseDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function RoleAuditUserResponseDtoFromJSON(json: any): RoleAuditUserResponseDto {
    return RoleAuditUserResponseDtoFromJSONTyped(json, false);
}

export function RoleAuditUserResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleAuditUserResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function RoleAuditUserResponseDtoToJSON(json: any): RoleAuditUserResponseDto {
    return RoleAuditUserResponseDtoToJSONTyped(json, false);
}

export function RoleAuditUserResponseDtoToJSONTyped(value?: RoleAuditUserResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

